/* IMPERFECTS — SITE FOOTER */
(function () {
  var MOBILE = '(max-width: 768px)';

  function sync(root) {
    root.classList.add('sf-js');
    var mq = window.matchMedia(MOBILE);
    var groups = root.querySelectorAll('.sf-menu');

    for (var i = 0; i < groups.length; i++) {
      var d = groups[i];
      var s = d.querySelector('.sf-menu__toggle');

      if (mq.matches) {
        d.open = false;
        if (s) { s.removeAttribute('aria-hidden'); s.removeAttribute('tabindex'); }
      } else {
        d.open = true;
        if (s) s.setAttribute('tabindex', '-1');
      }
    }
  }

  function setText(root, selector, value, withBreak) {
    var node = root.querySelector(selector);
    if (!node || typeof value !== 'string') return;
    var textNode = node.lastChild;
    if (!textNode || textNode.nodeType !== 3) {
      textNode = document.createTextNode('');
      node.appendChild(textNode);
    }
    if (textNode.nodeValue !== value) textNode.nodeValue = value;
    node.hidden = !value;
    if (withBreak && value && !node.querySelector('br')) node.insertAdjacentHTML('afterbegin', '<br>');
  }

  // Opening hours arrive as { days, time } rows from Storyblok; stack them
  // as a two-column list instead of one comma-joined line.
  function setHours(root, rows, text) {
    var node = root.querySelector('[data-space-hours]');
    if (!node) return;
    if (!Array.isArray(rows) || !rows.length) {
      setText(root, '[data-space-hours]', text, false);
      return;
    }
    while (node.firstChild) node.removeChild(node.firstChild);
    node.classList.add('sf-hours');
    for (var i = 0; i < rows.length; i++) {
      var row = document.createElement('span');
      row.className = 'sf-hours__row';
      var days = document.createElement('span');
      days.textContent = rows[i].days || '';
      var time = document.createElement('span');
      time.textContent = rows[i].time || '';
      row.appendChild(days);
      row.appendChild(time);
      node.appendChild(row);
    }
    node.hidden = false;
  }

  function updateLiveData(root) {
    var endpoint = root.getAttribute('data-space-info-url');
    if (!endpoint || root.getAttribute('data-space-info-loading') === 'true') return;
    root.setAttribute('data-space-info-loading', 'true');

    fetch(endpoint, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Footer space-info request failed');
        return response.json();
      })
      .then(function (data) {
        setText(root, '[data-space-address-line-1]', data.addressLine1, false);
        setText(root, '[data-space-address-line-2]', data.addressLine2, true);

        var space = root.querySelector('.sf-space');
        var suppressHours = space && space.getAttribute('data-space-suppress-hours') === 'true';
        if (!suppressHours) {
          setHours(root, data.hoursRows, data.hours);
          setText(root, '[data-space-entrance-note]', data.entranceNote, true);
          if (space) space.classList.toggle('sf-space--noshours', !data.hours);
        }

        var eventItem = root.querySelector('[data-footer-events-item]');
        var eventLink = eventItem && eventItem.querySelector('a');
        if (eventLink && data.upcomingEventSoon && !eventLink.querySelector('.sf-pip')) {
          eventLink.insertAdjacentHTML('beforeend', '<span class="sf-pip" aria-hidden="true"></span><span class="visually-hidden" data-footer-events-note> — event coming up</span>');
        } else if (eventLink && !data.upcomingEventSoon) {
          var pip = eventLink.querySelector('.sf-pip');
          var note = eventLink.querySelector('[data-footer-events-note]');
          if (pip) pip.remove();
          if (note) note.remove();
        }
      })
      .catch(function () {
        // The static Liquid fallback is the intended failure state.
      })
      .finally(function () {
        root.removeAttribute('data-space-info-loading');
      });
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Klaviyo's own onsite.js auto-detects this form and calls preventDefault()
  // on submit before doing nothing useful with it (confirmed live 2026-08-04)
  // -- likely a leftover hook from the old popup-based signup. Binding in the
  // capture phase and calling stopImmediatePropagation() first guarantees this
  // handler runs before any bubble-phase listener onsite.js attaches,
  // regardless of script load order.
  function initNewsletterSignup(root) {
    var form = root.querySelector('[data-klaviyo-signup]');
    if (!form || form.getAttribute('data-klaviyo-bound') === 'true') return;
    form.setAttribute('data-klaviyo-bound', 'true');

    var input = form.querySelector('.sf-signup__input');
    var button = form.querySelector('.sf-signup__submit');
    var successMsg = form.querySelector('[data-klaviyo-signup-success]');
    var errorMsg = form.querySelector('[data-klaviyo-signup-error]');
    var apiKey = form.getAttribute('data-klaviyo-api-key');
    var listId = form.getAttribute('data-klaviyo-list-id');

    function showError(text) {
      if (successMsg) successMsg.hidden = true;
      if (errorMsg) { errorMsg.textContent = text; errorMsg.hidden = false; errorMsg.focus(); }
    }

    function showSuccess() {
      if (errorMsg) errorMsg.hidden = true;
      if (successMsg) { successMsg.hidden = false; successMsg.focus(); }
      if (input) input.value = '';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var email = input ? input.value.trim() : '';
      if (!EMAIL_RE.test(email)) {
        showError('Enter a valid email address.');
        return;
      }
      if (!apiKey || !listId) {
        showError('Signup is temporarily unavailable.');
        return;
      }

      if (button) button.disabled = true;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(apiKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': '2026-07-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer signup form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        })
      })
        .then(function (response) {
          if (response.ok || response.status === 202) {
            showSuccess();
          } else {
            showError('Something went wrong. Please try again.');
          }
        })
        .catch(function () {
          showError('Something went wrong. Please try again.');
        })
        .finally(function () {
          if (button) button.disabled = false;
        });
    }, { capture: true });
  }

  function init() {
    var roots = document.querySelectorAll('.sf');
    if (!roots.length) return;

    for (var i = 0; i < roots.length; i++) {
      sync(roots[i]);
      updateLiveData(roots[i]);
      initNewsletterSignup(roots[i]);
    }

    var mq = window.matchMedia(MOBILE);
    var handler = function () {
      var r = document.querySelectorAll('.sf');
      for (var j = 0; j < r.length; j++) sync(r[j]);
    };
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else if (mq.addListener) mq.addListener(handler);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.sf')) init();
  });
})();
